import { render } from "./GrayCoverVue.vue?vue&type=template&id=e76f33b8&scoped=true"
import script from "./GrayCoverVue.vue?vue&type=script&lang=js"
export * from "./GrayCoverVue.vue?vue&type=script&lang=js"

import "./GrayCoverVue.vue?vue&type=style&index=0&id=e76f33b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e76f33b8"]])

export default __exports__